import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    ShowButton,
    EditButton,
    TextInput,
    ReferenceField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    DateField,
    DateInput,
} from 'react-admin';

const filingFilters = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="Type" source="type" name="Type" />,
    <DateInput label="Date" source="date" name="date" />,
    <TextInput label="Companies House" source="companiesHouse" name="companiesHouse" />,
];

const ListTitle = () => {
    return (
        <span>
            { 'Companies House Filing History' }
        </span>
    );
}

const ListActions = () => {
    return(
        <TopToolbar>
            <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const AdminCompaniesHouseFilingHistoryList = () => {
    return (
        <List
            title={ <ListTitle /> }
            sort={{ field: 'date', order: 'DESC' }}
            actions={<ListActions/>}
            filters={ filingFilters }>
            <Datagrid bulkActionButtons={false}>
                <TextField source="id"/>
                <DateField source="date" />
                <TextField source="type" />
                <ReferenceField
                    source="companiesHouse"
                    reference="companies_houses"
                    link="show"
                >
                    <TextField source="companyName"/>
                </ReferenceField>
                <>
                    <ShowButton/>
                    <EditButton/>
                </>
            </Datagrid>
        </List>
    );
}